
import { Component } from 'vue-property-decorator';
import { Route } from 'vue-router';
import { IAggregateResultHypermediaRepresentation } from '../../shared/contracts/AggregateContract';
import { performance } from '../../shared/services/PerformanceService';
import store from '../../store/store';
import OverviewBase from './OverviewBase.vue';

@Component({})
export default class AccountOverview extends OverviewBase {
    async beforeRouteEnter(to: Route, from: Route, next: Function) {
        performance.track('Account Dashboard');
        await store.dispatch('aggregate/fetchAccountsAggregate');
        next();
    }

    protected get aggregate(): IAggregateResultHypermediaRepresentation {
        return this.aggregateState.accountsAggregate;
    }

    protected get title(): string {
        return 'Account Dashboard';
    }

    protected get placeholder(): string {
        return 'Search on account';
    }

    public goToDetails(id: string, name: string) {
        this.$router.push({ name: 'accountDetails', params: { id } });
    }
}
